import { ADD_USER, SIGN_OUT } from "../../actions/actionTypes/auth";

const initialState = {
  cognitoUser: {},
  userInfo: {},
  sessionExpired: false,
  applicationRelevantStorageInformation: { hasSeenTutorial: false, hasSeenIntro: false },
};

export function auth(state = initialState, action: any) {
  switch (action.type) {
    case ADD_USER:
      const { cognitoUser, userInfo, sessionExpired } = action.payload;
      return {
        ...state,
        cognitoUser,
        userInfo,
        sessionExpired,
      };
    case SIGN_OUT:
      return { ...initialState, ...action.payload };
    default:
      return state;
  }
}
